import { makeStyles } from 'tss-react/mui';

import { circularProgressClasses } from '@mui/material';

export default makeStyles({ name: 'Diagram' })({
    label: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '100%',
        flex: 2
    },
    score: {
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '100%',
        flex: 1
    },
    _green: {
        color: '#05A569'
    },
    _orange: {
        color: '#EB8F01'
    },
    _red: {
        color: '#F5726A'
    },
    _gray: {
        color: '##E6E6E6'
    },
    diagram: {
        padding: '56px 16px',
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'center'
    },
    diagramBackdrop: {
        color: 'inherit',
        opacity: 0.3,
        gridRow: 1,
        gridColumn: 1
    },
    diagramValue: {
        color: 'inherit',
        gridRow: 1,
        gridColumn: 1,
        [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
        }
    },
    diagramLabel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gridRow: 1,
        gridColumn: 1
    },
    diagramLabelScore: {
        color: 'inherit',
        fontSize: 40,
        fontWeight: 700,
        lineHeight: '48px'
    },
    diagramLabelRisk: {
        color: 'inherit',
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '21px'
    }
});
